import { Component, Input, OnInit } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { CheckTriage, TriageService } from 'app/services/triage.service';
import { JourneyService } from 'modules/journeys/services/journey.service';
import { ToggleEvent } from 'shared/components/accordion/accordion.component';

@Component({
	selector: 'appointment-details-triage-data',
	templateUrl: './appointment-details-triage-data.component.html',
	styleUrls: ['./appointment-details-triage-data.component.scss'],
})
export class AppointmentDetailsTriageDataComponent implements OnInit {
	public screeningResult: string;
	public triageData: CheckTriage;
	public currentTimeout: NodeJS.Timeout;

	@Input()
	public event: ICalendarEvent;

	@Input()
	public isFirstSession = false;

	constructor(
		public journeyService: JourneyService,
		public triageService: TriageService,
		public actionTrackerService: ActionTrackerService
	) {}

	public ngOnInit(): void {
		if (this.isScreeningSession()) {
			this.getScreeningResult();
			return;
		}

		if (this.event.triageId) {
			this.getTriageData();
		}
	}

	public onToggleAccordion(toggleEvent: ToggleEvent): void {
		if (!toggleEvent.isOpen) {
			clearTimeout(this.currentTimeout);
			return;
		}

		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.Details,
			ITEM_TYPE.TriageCard,
			INTERACTION_TYPE.Click
		);

		this.currentTimeout = setTimeout(() => {
			this.actionTrackerService.eventTracker(
				SCOPE_TYPE.Appointment,
				SUBSCOPE_TYPE.Details,
				ITEM_TYPE.TriageCard,
				INTERACTION_TYPE.Seen
			);
		}, 3000);
	}

	public isScreeningSession(): boolean {
		return this.event.subscription?.coordinatedCareType === 'screening';
	}

	public getScreeningResult(): void {
		this.journeyService
			.getUserScreening(this.event.profileId)
			.subscribe((result) => {
				if (result.found) {
					this.screeningResult = result.label;
				}
			});
	}

	public getTriageData(): void {
		this.triageService
			.checkTriage({
				professionalId: this.event.professionalId,
				profileId: this.event.profileId,
			})
			.subscribe((result) => {
				this.triageData = result;
			});
	}

	public formatTriageReasons(): string {
		return this.triageData.reasonsForTherapy.reasons
			?.map((reason: string | { OTHER: string }) => {
				if (typeof reason === 'string') {
					return reason;
				}

				return reason.OTHER;
			})
			.join(', ');
	}
}
